import { isNotEmpty } from "./type";

export function generateTitle(
  ...components: Array<string | null | undefined>
): string {
  return [...components, "Thickt"].filter(isNotEmpty).join(" - ");
}
